import type { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'f/:embedSlug',
    loadComponent: () =>
      import('@features/form-page/form-page.component').then(m => m.FormPageComponent),
  },
  {
    path: 'f/:embedSlug/success',
    loadComponent: () =>
      import('@features/form-page/form-success.component').then(m => m.FormSuccessComponent),
  },
  { path: '', redirectTo: 'f/not-found', pathMatch: 'full' },
];
